import { LitElement, html, css, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { PAGE } from '../util/page';
// import { shouldUseLegacyLinks } from '../util/plans';
const { VITE_LITEHOUSE_FOOTER_FINE_PRINT } = import.meta.env;

const getFooterFinePrintSrc = (src?: string): string | undefined => {
    if (!src || typeof window === 'undefined') return src;

    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    if (!isLocalhost) return src;

    try {
        const parsed = new URL(src, window.location.origin);
        if (parsed.hostname === 'config-cdn.bcbsnc.com') {
            return `${parsed.pathname}${parsed.search}`;
        }
    } catch {
        return src;
    }

    return src;
};

@customElement('footer-component')
export class FooterComponent extends LitElement {
    static styles = css`
        .lh-footer__fine-print {
            font-family: var(--lh-font-family-sans-serif);
            font-size: var(--lh-text-font-size-xs);
            color: var(--mode-color-text);
            margin-bottom: 0;
            margin-top: 0;
            position: relative;
            top: -20px;
        }
        a {
            color: var(--mode-typography-text);
        }

        p + *,
        ul + * {
            margin-block-start: var(--lh-spacing-16);
        }
        .footer {
            margin-top: 0;
            padding-top: 20px;
        }

        .pre-ol {
            margin-bottom: 0px;
        }
        ol {
            margin-top: 0px;
        }
    `;

    @property({ type: String })
    page?: PAGE;

    @property({ type: String })
    effectiveStartDate?: string;

    get renderDisclosure() {
        return html` ${this.page === PAGE.DETAILS || this.page === PAGE.COMPARE
                ? html`
                      <p>
                          <sup>1</sup> Out-of-network Emergency Services are covered at the in-network benefit level for
                          all plans.
                      </p>
                  `
                : nothing}
            <p>
                <strong>Attention:</strong> This website is operated by Blue Cross and Blue Shield of North Carolina and
                is not the Health Insurance Marketplace® website at
                <a class="text-color" href="https://HealthCare.gov" target="_blank">HealthCare.gov</a>. This website
                does not display all Qualified Health Plans (QHPs) available through
                <a class="text-color" href="https://HealthCare.gov" target="_blank">HealthCare.gov</a>. To see all
                available QHP options, go to the Health Insurance Marketplace® website at
                <a class="text-color" href="https://HealthCare.gov" target="_blank">HealthCare.gov</a>.
            </p>
            <p class="pre-ol">
                Also, you should visit the Health Insurance Marketplace® website at
                <a class="text-color" href="https://HealthCare.gov" target="_blank">HealthCare.gov</a> if:
            </p>
            <ol>
                <li>You want to select a catastrophic health plan.</li>
                <li>You want to enroll members of your household in dental coverage.</li>
            </ol>
            <p>Actual subsidy is determined by the federal government.</p>
            <p>$0 benefits: Benefits and member cost share vary by plan design.</p>
            <p>
                Special Enrollment Periods (SEPs) are available for individuals with qualifying life events. The federal
                government determines subsidy eligibility and amount for health insurance plans purchased on the
                federally facilitated Health Insurance Marketplace. Details regarding SEP requirements and subsidies can
                be found at HealthCare.gov.
            </p>
            <p>
                Health Insurance Marketplace is a registered trademark of the Department of Health & Human Services.
            </p>`;
    }

    render() {
        const finePrintSrc = getFooterFinePrintSrc(VITE_LITEHOUSE_FOOTER_FINE_PRINT);

        return html`
            <lh-footer class="footer" fine-print-src=${finePrintSrc}>
                <lh-logo slot="logo" name="bcbsnc-full" inverse></lh-logo>
                <div slot="disclosures">${this.renderDisclosure}</div></lh-footer
            >
        `;
    }
}
